'use strict'

document.addEventListener('DOMContentLoaded', () => {
  /********************************
   * Vars
   *******************************/
  const html = document.querySelector('html');
  const body = document.querySelector('body');
  const screenWidth = window.innerWidth;

  /********************************
   * Section: Reviews
   *******************************/
  const sectionReviews = document.querySelectorAll('.section-reviews');

  if (sectionReviews.length) {
    function initializeSlider(slider, slideCount, section) {
      if (screenWidth >= 992 && slideCount > 3) {
        startSlider(slider, section);
      } else if (screenWidth >= 768 && screenWidth <= 991 && slideCount > 2) {
        startSlider(slider, section);
      } else if (screenWidth <= 767 && slideCount > 1) {
        startSlider(slider, section);
      }
    }

    function startSlider(sliderInit, section) {
      sliderInit.closest('.swiper-slider-wrap').classList.add('slider-isActive');

      const nextButton = section.querySelector('.button-next');
      const prevButton = section.querySelector('.button-prev');
      const scrollbar = section.querySelector('.swiper-scrollbar');

      const isNavigationPresent = !!(nextButton && prevButton);

      const swiperConfig = {
        loop: !isNavigationPresent,
        spaceBetween: 16,
        slidesPerView: 1.2,
        breakpoints: {
          768: {
            spaceBetween: 16,
            slidesPerView: 2.3,
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 24,
          }
        }
      };

      if (nextButton && prevButton) {
        swiperConfig.navigation = {
          nextEl: nextButton,
          prevEl: prevButton,
        };
      }

      if (scrollbar) {
        swiperConfig.scrollbar = {
          el: scrollbar,
          draggable: true,
        };
      }

      new Swiper(sliderInit, swiperConfig);
    }

    sectionReviews.forEach(section => {
      const slider = section.querySelector('.slider_init');
      const slideCount = section.querySelectorAll('.swiper-slide').length;

      initializeSlider(slider, slideCount, section);
    });
  }

  /********************************
   * Tabs Product
   *******************************/
  const tabsContainers = document.querySelectorAll('.tabs-container');

  if(tabsContainers.length){
    tabsContainers.forEach(container => {
      const controller = container.querySelector('.tabs-controller');
      const contentItems = container.querySelectorAll('.tab-content-item');
      const tabButtons = container.querySelectorAll('.tab-btn');

      if (!controller || !contentItems.length) return;

      controller.addEventListener('click', (event) => {
        const clickedBtn = event.target.closest('.tab-btn');

        if (!clickedBtn || clickedBtn.classList.contains('active')) return;

        const targetTabId = clickedBtn.getAttribute('data-tab');

        tabButtons.forEach(btn => {
          btn.classList.toggle('active', btn === clickedBtn);
        });

        contentItems.forEach(item => {
          const itemTabId = item.getAttribute('data-tab');
          item.classList.toggle('active', itemTabId === targetTabId);
        });
      });
    });
  }

  /********************************
   * Accordion
   *******************************/
  const accordionGroups = document.querySelectorAll('.accordion-wrap');

  if (accordionGroups.length > 0) {
    accordionGroups.forEach(accordion => {
      const isAccordionActive = () => {
        const isMenu = accordion.classList.contains('header-main-navigation');
        const isMobile = window.innerWidth <= 991;
        return isMenu ? isMobile : true;
      };

      const initAccordions = () => {
        if (!isAccordionActive()) return;

        if (accordion.classList.contains('open-first-child')) {
          setTimeout(() => {
            const firstItem = accordion.querySelector('.accordion-item');
            if (firstItem) openAccordionItem(firstItem);
          }, 1300);
        }

        if (accordion.classList.contains('open-all-child')) {
          setTimeout(() => {
            const allItems = accordion.querySelectorAll('.accordion-item');
            allItems.forEach(item => openAccordionItem(item));
          }, 1300);
        }
      };

      const openAccordionItem = (item) => {
        const content = item.querySelector('.accordion-description');
        const inner = item.querySelector('.accordion-inner-content');
        const padding = +item.dataset.descriptionPadding || 12;

        item.classList.add('active');
        content.style.height = (inner.scrollHeight + padding) + "px";
      };

      const closeAccordionItem = (item) => {
        const content = item.querySelector('.accordion-description');
        item.classList.remove('active');
        content.style.height = "0px";
      };

      accordion.addEventListener('click', function (e) {
        if (!isAccordionActive()) return;

        const target = e.target;
        const accordionItem = target.closest('.accordion-item');

        if (!accordionItem || target.closest('.accordion-description')) return;

        const isActive = accordionItem.classList.contains('active');
        const activeItem = accordion.querySelector('.accordion-item.active');

        if (isActive) {
          closeAccordionItem(accordionItem);
        } else {
          if (activeItem) closeAccordionItem(activeItem);
          openAccordionItem(accordionItem);
        }
      });

      window.addEventListener('resize', () => {
        if (accordion.classList.contains('header-main-navigation') && window.innerWidth > 991) {
          const items = accordion.querySelectorAll('.accordion-item');
          items.forEach(item => {
            item.classList.remove('active');
            item.querySelector('.accordion-description').style.height = '';
          });
        }
      });

      initAccordions();
    });
  }

  /********************************
   * Loop price sync
   *******************************/
  const loopContainers = document.querySelectorAll('.loop-subscription-container');

  if (loopContainers.length) {
    const getLoopPriceData = (productId) => {
      if (!window.loopProps?.[productId]) return null;
      const props = window.loopProps[productId];
      const isOnetime = !props.sellingPlanGroupId || props.sellingPlanGroupId === 'loop-one-time-purchase';
      const variant = props.variant || props.product?.variants?.[0];
      if (!variant) return null;

      const originalPrice = loopFormatMoney(variant.price, true);

      if (isOnetime) {
        return { salePrice: originalPrice, compareAtPrice: null };
      }

      const allocation = variant.selling_plan_allocations?.find(
        (a) => String(a.selling_plan_group_id) === String(props.sellingPlanGroupId)
      );
      if (!allocation) return null;

      const loopPriceEl = document.querySelector(`#loop-price-${variant.id}-${props.sellingPlanGroupId}`);
      const subPrice = loopPriceEl?.textContent?.trim() || loopFormatMoney(allocation.per_delivery_price, true);
      const displayedSubNum = parseFloat(subPrice.replace(/[^0-9.]/g, ''));
      const originalPriceNum = variant.price / 100;
      const discountPercent =
        originalPriceNum > 0 && displayedSubNum > 0 && displayedSubNum < originalPriceNum
          ? Math.round((1 - displayedSubNum / originalPriceNum) * 100) || null
          : null;

      return { salePrice: subPrice, compareAtPrice: originalPrice, discountPercent };
    };

    const updateAtcButtonPrice = (productId) => {
      const priceWrap = document.querySelector(`.atc-btn-price[data-product-id="${productId}"]`);
      if (!priceWrap) return;

      const data = getLoopPriceData(productId);
      if (!data) return;

      priceWrap.innerHTML = data.compareAtPrice
        ? `<s class="atc-btn-price__was">${data.compareAtPrice}</s><span class="atc-btn-price__now">${data.salePrice}</span>`
        : `<span class="atc-btn-price__original">${data.salePrice}</span>`;
    };

    const updateSectionPrice = (productId) => {
      const priceBlocks = document.querySelectorAll(`.product-info__price[data-loop-price-product-id="${productId}"]`);
      if (!priceBlocks.length) return;

      const data = getLoopPriceData(productId);
      if (!data) return;

      priceBlocks.forEach((priceBlock) => {
        const saleEl = priceBlock.querySelector('sale-price');
        const compareEl = priceBlock.querySelector('compare-at-price');

        if (saleEl) saleEl.textContent = data.salePrice;

        if (data.compareAtPrice) {
          if (compareEl) {
            compareEl.textContent = data.compareAtPrice;
            compareEl.hidden = false;
          } else {
            const newCompare = document.createElement('compare-at-price');
            newCompare.className = 'text-subdued line-through';
            newCompare.textContent = data.compareAtPrice;
            saleEl?.insertAdjacentElement('afterend', newCompare);
          }
        } else {
          if (compareEl) compareEl.hidden = true;
        }

        let badgeEl = priceBlock.querySelector('.loop-price-discount-badge');
        if (data.discountPercent) {
          if (!badgeEl) {
            badgeEl = document.createElement('a');
            badgeEl.setAttribute('href', '#product-info__buy-buttons');
            badgeEl.className = 'loop-price-discount-badge';
            priceBlock.querySelector('.rating-with-text')?.appendChild(badgeEl);
          }
          badgeEl.textContent = `${data.discountPercent}% OFF†`;
          badgeEl.hidden = false;
        } else if (badgeEl) {
          badgeEl.hidden = true;
        }
      });
    };

    const updateAllLoopPrices = (productId) => {
      updateAtcButtonPrice(productId);
      updateSectionPrice(productId);
    };

    document.addEventListener('change', (e) => {
      const radio = e.target.closest('input[name="loop_purchase_option"]');
      if (!radio) return;
      const productId = radio.dataset.productId;
      if (productId) setTimeout(() => updateAllLoopPrices(productId), 50);
    });

    document.addEventListener('change', (e) => {
      const select = e.target.closest('select.loop-selling-plan-selector');
      if (!select) return;
      const productId = select.dataset.productId;
      if (productId) setTimeout(() => updateAllLoopPrices(productId), 50);
    });

    document.addEventListener('loopWidgetInitialized', (e) => {
      const productId = e?.detail?.productId;
      if (productId) updateAllLoopPrices(productId);
    });

    const atcPriceObserver = new MutationObserver(() => {
      document.querySelectorAll('.atc-btn-price[data-product-id]').forEach((el) => {
        const productId = el.dataset.productId;
        if (window.loopProps?.[productId]) updateAllLoopPrices(productId);
      });
    });

    loopContainers.forEach((container) => {
      atcPriceObserver.observe(container, { attributes: true, attributeFilter: ['style'] });
    });
  }

  /********************************
   * Section: Single product
   *******************************/
  const singleProducts = document.querySelectorAll('.single-product');

  if (singleProducts.length) {
    const stopAllVideos = (container) => {
      const videos = container.querySelectorAll('[js-big-video="video"]');
      videos.forEach(video => {
        video.pause();
        const holder = video.closest('.video-holder');
        holder?.querySelector('.play-video')?.classList.remove('active');
      });
    };

    const initVideoControls = (sliderContainer) => {
      const holders = sliderContainer.querySelectorAll('.video-holder');

      holders.forEach(holder => {
        const video = holder.querySelector('[js-big-video="video"]');
        const playBtn = holder.querySelector('[js-big-video="play"]');
        const poster = holder.querySelector('.video-poster');

        if (!video) return;

        holder.addEventListener('click', (e) => {
          e.preventDefault();
          if (video.paused) {
            stopAllVideos(sliderContainer);
            video.play();
            playBtn?.classList.add('active');
            if (poster) poster.style.display = 'none';
          } else {
            video.pause();
            playBtn?.classList.remove('active');
          }
        });
      });
    };

    const startVideoSlider = (sliderElement) => {
      sliderElement.closest('.video-slider-wrap').classList.add('slider-init');

      new Swiper(sliderElement, {
        slidesPerView: 2.2,
        spaceBetween: 16,
        watchSlidesProgress: true,
        breakpoints: {
          1024: {
            slidesPerView: 3.2,
            spaceBetween: 20
          }
        },
        on: {
          slideChange: () => stopAllVideos(sliderElement)
        }
      });
    };

    singleProducts.forEach(section => {
      /*************** video_carousel ***************/
      const videoSliderBlock = section.querySelector('.video-slider');
      if (videoSliderBlock) {
        const videoSliderWrap = videoSliderBlock.querySelector('.video-slider-wrap');
        const videoSliderInit = videoSliderBlock.querySelector('.slider_video_init');
        const videoSlides = videoSliderBlock.querySelectorAll('.swiper-slide');
        const screenWidth = window.innerWidth;

        if (videoSliderInit && videoSlides.length > 0) {
          const isMobile = screenWidth < 1024;
          const isDesktop = screenWidth >= 1024;

          if (isMobile && videoSlides.length > 2) {
            videoSliderWrap?.classList.add('init-slider');
            startVideoSlider(videoSliderInit);
          } else if (isDesktop && videoSlides.length > 3) {
            startVideoSlider(videoSliderInit);
          }

          initVideoControls(videoSliderInit);
        }
      }

      /*************** Main slider ***************/
      const mainSlider = section.querySelector('.slider_init');
      if (mainSlider && section.querySelectorAll('.slider_init .swiper-slide').length > 1) {
        new Swiper(mainSlider, {
          loop: true,
          slidesPerView: 1,
          navigation: {
            nextEl: section.querySelector('.slider-button-next'),
            prevEl: section.querySelector('.slider-button-prev'),
          },
          pagination: { clickable: true, el: section.querySelector(".swiper-pagination") }
        });
      }

      /*************** slider_reviews ***************/
      const reviewsSlider = section.querySelector('.slider-reviews-init');
      if (reviewsSlider && section.querySelectorAll('.slider-reviews-init .swiper-slide').length > 1) {
        reviewsSlider.closest('.slider-reviews-inner').classList.add('init');

        new Swiper(reviewsSlider, {
          slidesPerView: 1.25,
          spaceBetween: 16,

          navigation: {
            nextEl: reviewsSlider.querySelector('.button-next'),
            prevEl: reviewsSlider.querySelector('.button-prev'),
          },
          scrollbar: {
            el: reviewsSlider.querySelector('.swiper-scrollbar'),
            draggable: true,
          },
        });
      }
    });
  }
});